import * as React from "react"

const EyesIcon = (props) => (
  <svg
    width={24}
    height={26}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.53 5.479a.759.759 0 0 0 0-1.068.746.746 0 0 0-1.06 0l-16 16.11a.759.759 0 0 0 0 1.069.746.746 0 0 0 1.06 0l2.847-2.867c1.367.648 2.94 1.074 4.623 1.074 2.684 0 5.09-1.085 6.82-2.422.867-.67 1.583-1.417 2.089-2.15.492-.714.841-1.497.841-2.225s-.35-1.51-.841-2.224c-.506-.734-1.222-1.481-2.088-2.151-.263-.203-.54-.4-.832-.588L20.53 5.48ZM16.9 9.135l-1.771 1.783c.392.597.621 1.312.621 2.082 0 2.085-1.679 3.776-3.75 3.776-.764 0-1.475-.23-2.068-.626l-1.417 1.427a9.195 9.195 0 0 0 3.485.71c2.287 0 4.38-.93 5.907-2.11.762-.589 1.364-1.226 1.77-1.814.419-.608.573-1.084.573-1.363 0-.28-.154-.755-.573-1.363-.406-.588-1.008-1.225-1.77-1.814-.313-.242-.65-.473-1.008-.688Zm-5.87 5.91c.294.141.623.22.97.22A2.258 2.258 0 0 0 14.25 13c0-.35-.079-.681-.22-.977l-3 3.022Z"
      fill="#000"
    />
    <path
      d="M12 6.203c1.033 0 2.025.16 2.954.435.178.052.23.275.1.406l-.827.833a.254.254 0 0 1-.238.068A8.814 8.814 0 0 0 12 7.714c-2.287 0-4.38.929-5.907 2.11-.762.588-1.364 1.225-1.77 1.813-.419.608-.573 1.084-.573 1.363 0 .28.154.755.573 1.363.355.514.86 1.066 1.49 1.59.115.095.126.27.02.376l-.71.715a.246.246 0 0 1-.333.016 9.56 9.56 0 0 1-1.699-1.836C2.6 14.511 2.25 13.728 2.25 13c0-.728.35-1.51.841-2.224.506-.734 1.222-1.481 2.088-2.151C6.91 7.288 9.316 6.203 12 6.203Z"
      fill="#000"
    />
    <path
      d="M12 9.224c.12 0 .238.006.354.017.196.018.268.253.129.393l-1.216 1.223a2.264 2.264 0 0 0-1.395 1.405l-1.212 1.22c-.14.14-.375.07-.394-.128A3.851 3.851 0 0 1 8.25 13c0-2.085 1.679-3.776 3.75-3.776Z"
      fill="#000"
    />
  </svg>
)

export default EyesIcon
